export const MOBILE_BREAKPOINT = 840;
